export const environment = {
  production: false,
  GROK_API_KEY: 'xxxxxx',
  GEMINI_API_KEY:'AIzaSyABm35G3nkx8jyLnM3M56Qn41CXZ_-WNl4',
  zaiApikey: '73d8264c8a5441869777321b3852a25c.F3WrWUYZ6JUZ46vI',
  flash3:'AIzaSyABm35G3nkx8jyLnM3M56Qn41CXZ_-WNl4',
  // ---------- OpenAI / X.ai / Google ----------
  videoApiBaseUrl: 'https://clarichat-video-api-630346558823.us-central1.run.app',
  soraLambdaUrl: 'https://o3hhhyiy3it3cbqskobf6ch5740waovv.lambda-url.us-west-2.on.aws/',
  wowAliBaseUrl: 'https://wow-ali-630346558823.us-central1.run.app',
  GLM_API_KEY: '73d8264c8a5441869777321b3852a25c.F3WrWUYZ6JUZ46vI',
  apiKey: '0NqmzlTPyDguWnvaPeyQGuj5Nn0b3TNDZPdfeOrkyhuuJqBBW5lo6DMJs5eAyilCeVEcHH6fCoT3BlbkFJjuEpITQQIzUUY5zonBHqfibYzvBjdZpiRPGHDNGIv',
  OPENAI_API_KEY: '0NqmzlTPyDguWnvaPeyQGuj5Nn0b3TNDZPdfeOrkyhuuJqBBW5lo6DMJs5eAyilCeVEcHH6fCoT3BlbkFJjuEpITQQIzUUY5zonBHqfibYzvBjdZpiRPGHDNGIv',
  vertexClaudeChatUrl:'https://vertex-claude-chat-ijxfuerwzq-uc.a.run.app ',
  vertexClaudeApiKey: "xxxxxx",
  veoClientId: 'xxxxxx',
  glm5ChatEndpoint: 'https://wt6el3ei7teiqkkexfikmm3zme0blkqa.lambda-url.us-east-1.on.aws/ ',
  // Cloud Function (enhanceResume) routes
  videoJobsBaseUrl: 'https://us-central1-ringed-codex-484318-g6.cloudfunctions.net/enhanceResume',
  // Media processing – routed through enhanceResume (us-central1)
  mediaFunctionsBaseUrl: 'https://us-central1-ringed-codex-484318-g6.cloudfunctions.net/enhanceResume',
  mediaUploadUrl: 'https://us-central1-ringed-codex-484318-g6.cloudfunctions.net/enhanceResume/createMediaUploadUrl',
  mediaUploadToGcsUrl: 'https://us-central1-ringed-codex-484318-g6.cloudfunctions.net/enhanceResume/uploadMediaToGcs',
  mediaAnalyzeUrl: 'https://us-central1-ringed-codex-484318-g6.cloudfunctions.net/enhanceResume/analyzeMedia',
  mediaPollJobUrl: 'https://us-central1-ringed-codex-484318-g6.cloudfunctions.net/enhanceResume/pollMediaJob',
  mediaListUrl: 'https://us-central1-ringed-codex-484318-g6.cloudfunctions.net/enhanceResume/mediaList',
  googleDocsServiceUrl: 'https://v2quhhx6duwsv3i4m7gcbrlafm0paopu.lambda-url.us-east-1.on.aws/',
  /** OAuth 2.0 Web client for Google Drive / Docs (GIS token client). Must match Google Cloud Console. */
  oauth2ClientId:
    '799504398927-pv689avsudkpab4pr02oj8vnsrequh15.apps.googleusercontent.com',
  // Gemini 3 Flash Preview endpoint (deployed Cloud Function)
  geminiEndpoint: 'https://k2orvt5ph5hljzmaroll5li4rq0egxpx.lambda-url.us-east-1.on.aws/',
  stabilityStudioEndpoint: 'https://hlprq25tin3rscim7bqr3xs6jq0qtmwu.lambda-url.us-west-2.on.aws/',
  openAIEndpoint:'https://v47qf4emwmutnsoijea4mxtaqm0vbdcq.lambda-url.us-east-1.on.aws/',
  chatgptMiniEndpoint: 'https://lnukhx6apmcota3kizpzilm3wq0eebip.lambda-url.us-east-1.on.aws/',
  grokEndpoint: 'https://xmdeegksg65yavlru3xubz4h6u0pviys.lambda-url.us-east-1.on.aws/',
  glmEndpoint: 'https://ye2tohfqc65hlzn4ib5apswcny0peqop.lambda-url.us-east-1.on.aws/',
  cogxLambdaUrl: 'https://ls55ggjcjir7oaojdbmcvfwtju0qqvqe.lambda-url.us-west-2.on.aws/',
  novaReel11LambdaUrl: '',
  // Video job collections (Firestore)
  videoJobsCollectionName: 'videoJobs',
  videoSoraJobsCollectionName: 'videoSoraJobs',
  videoVeoJobsCollectionName: 'videoVeoJobs',
  mediaCollectionName: 'media',
  mediaSessionId: 'user-session',

  /** Firebase web SDK — single source of truth (see also `firebase.config.ts`, `gen2ai/fire-init.ts`). */
  firebaseConfig: {
    apiKey: 'AIzaSyCH05ofyXFaN5NP2Pv1x3bLcpaG0MmjB_c',
    authDomain: 'clarichatai.firebaseapp.com',
    databaseURL: 'https://clarichatai-default-rtdb.firebaseio.com',
    projectId: 'clarichatai',
    storageBucket: 'clarichatai.firebasestorage.app',
    messagingSenderId: '630346558823',
    appId: '1:630346558823:web:c510489ec490d8bb8153c2',
    measurementId: 'G-H06QS481W1'
  },
  /** Web OAuth client ID — align with resumeenhancer worker GOOGLE_CLIENT_ID / GIS Drive client. */
  firebaseGoogleWebClientId:
    '799504398927-pv689avsudkpab4pr02oj8vnsrequh15.apps.googleusercontent.com',

  uploadBucketName: 'clarichatai.firebasestorage.app',
  outputBucketName: 'clarichatai.firebasestorage.app'
};

